import { render } from "./CollezioneView.vue?vue&type=template&id=45fe3466&scoped=true"
import script from "./CollezioneView.vue?vue&type=script&lang=js"
export * from "./CollezioneView.vue?vue&type=script&lang=js"

import "./CollezioneView.vue?vue&type=style&index=0&id=45fe3466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fe3466"]])

export default __exports__